import { mapActions, mapGetters } from 'vuex'
// import moment from 'moment'
import { format } from '@/plugins/moment'
import Configuration from '@/agilis/util/Configuration'
import DataTableWithGroups from '@/agilis/components/DataTableWithGroups/DataTableWithGroups.vue'
import DataTableGroupingMixin from '@/agilis/components/DataTableWithGroups/common/DataTableGroupingMixin'
import L from 'lodash'

export default {
  name: 'DeliveryExecution',
  mixins: [DataTableGroupingMixin],

  props: {
    trackerDTO: Object,
    parentTrackerDTO: Object,
    wpGroupItems: Array,
    wpGroupData: Object,
    deliveryAssociations: {
      type: Array,
      default: () => []
    }
  },

  components: {
    DataTableWithGroups
  },

  data () {
    return {
      itemsKey: 'id',
      featureId: 'deliveryExecution',
      items: [],
      displayedWpIds: new Set()
    }
  },

  watch: {
    associatedPropositions: {
      deep: true,
      handler (newValue, oldValue) {
        const newPropositions = newValue.map(proposition => proposition.id)
        const oldPropositions = oldValue.map(proposition => proposition.id)
        if (!L.isEqual(newPropositions, oldPropositions)) {
          this.fetchData(newValue)
        }
      }
    },
    parentProposition: {
      handler (newValue, oldValue) {
        if (!L.isEqual(newValue, oldValue)) {
          this.fetchData([newValue])
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      'applicationId': 'contextStore/applicationId',
      'trackerTypeId': 'contextStore/trackerTypeId'
    }),
    title () {
      return this.$t('sales.label.deliveryExecutionTitle')
    },
    configuration () {
      return Configuration.getTrackerType(this.applicationId, this.trackerTypeId).trackerTypes.deliveryExecution.dataTable
    },
    footer () {
      return this.$t('sales.label.deliveryExecutionFooter', { lastUpdate: (format(this.items[0]?.lastUpdate || null, this.$t('format.dateTime'))) })
    },
    sequenceNumbers () {
      return L.uniqBy(this.wpGroupItems, 'sequenceNumber').map(item => (item.sequenceNumber))
    },
    parentProposition () {
      return this.sequenceNumbers.includes(this.parentTrackerDTO?.sequenceNumber) ? this.parentTrackerDTO : null
    },
    associatedPropositions () {
      const filteredAssociations = this.deliveryAssociations ? this.deliveryAssociations.filter(association => association.target.trackerTypeId === 'proposition') : []
      return filteredAssociations.map(association => association.target).filter(proposition => this.sequenceNumbers.includes(proposition.sequenceNumber))
    },
    propositions () {
      return [this.parentProposition, ...this.associatedPropositions].filter(Boolean)
    }
  },

  methods: {
    ...mapActions({
      notifyError: 'notificationStore/notifyError',
      startLoader: 'loaderStore/startLoader',
      stopLoader: 'loaderStore/stopLoader'
    }),

    fetchData () {
      this.startLoader({ id: 'fetch-data' })
      try {
        this.fetchClannWorkedDays().then(clannWorkedDays => {
          const decoratedItems = clannWorkedDays.map((wpClann) => this.decorateWpData(wpClann, this.wpGroupItems)).filter(Boolean)
          this.items = decoratedItems
        }).catch(error => {
          this.notifyError(error)
        })
      } catch (error) {
        this.notifyError(error)
      }
      this.stopLoader({ id: 'fetch-data' })
    },

    async fetchClannWorkedDays () {
      let responses = []
      try {
        responses = await Promise.all(this.propositions.map(proposition => {
          if (proposition?.sequenceNumber) {
            const startDate = format(this.trackerDTO.startDate || proposition.startDate, 'YYYYMMDD')
            const endDate = format(new Date(), 'YYYYMMDD')
            const url = this.$axios.agilisUrlDeliveryWorkedDays(proposition.sequenceNumber, startDate, endDate, 'MONTH')
            return this.$axios.get(url, this.$axios.agilisRequestConfig(url))
          }
          return Promise.resolve([])
        }))
      } catch (error) {
        this.notifyError(error)
      }
      return responses.reduce((acc, response) => {
        if (response?.data?.length) {
          acc = acc.concat(response.data)
        }
        return acc
      }, [])
    },

    getItemId (item) {
      return item.workPackageId.concat('-', item.aggregationLevel)
    },

    decorateWpData (wpClann, wpsDelivery) {
      const matches = wpsDelivery.filter(wpDelivery => {
        return wpDelivery.propositionId === wpClann.propositionId &&
          wpClann.workPackageType === 'WorkPackage3'
          ? wpDelivery.wpPropositionId?.toString() === wpClann.workPackageId
          : wpDelivery.workPackageId === wpClann.workPackageId
      })
      const wpDelivery = matches.length ? matches[0] : undefined
      if (!wpDelivery) {
        return null
      }
      const aggregationLevel = wpClann.aggregationLevel
      const formattedAggregationLevel = (aggregationLevel && typeof aggregationLevel === 'string')
        ? format(aggregationLevel, 'MM-YYYY', 'MMYYYY')
        : aggregationLevel || ''
      wpClann.aggregationLevel = formattedAggregationLevel
      return Object.assign({}, wpClann, wpDelivery, { id: this.getItemId(wpClann) })
    }
  }
}
